"use client";

import { useActionState } from "react";
import { loginAction, type LoginState } from "./actions";
import { Alert } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import { FieldRow, Input } from "@/components/ui/Input";
import { PasswordInput } from "@/components/ui/PasswordInput";
import { type Lang } from "@/lib/i18n";
import { useDict } from "@/components/i18n/DictProvider";

const initial: LoginState = { ok: false };

export function LoginForm({ lang, next }: { lang: Lang; next: string }) {
  const t = useDict();
  const [state, formAction, pending] = useActionState(loginAction, initial);

  return (
    <form action={formAction} className="grid gap-4">
      <input type="hidden" name="lang" value={lang} />
      <input type="hidden" name="redirect" value={next} />
      {state.ok === false && state.error ? <Alert tone="error">{state.error}</Alert> : null}
      <FieldRow label={t.auth.email}>
        <Input
          name="email"
          type="email"
          autoComplete="email"
          // RFC 5321's limit; the API accepted a 310-character address.
          maxLength={254}
          required
          placeholder="you@example.com"
          defaultValue={state.ok === false && "email" in state ? state.email : undefined}
          className="rounded-xl"
        />
      </FieldRow>
      <FieldRow label={t.auth.password}>
        <PasswordInput
          name="password"
          autoComplete="current-password"
          required
          className="rounded-xl"
        />
      </FieldRow>
      <Button type="submit" loading={pending} className="mt-1 w-full">
        {t.auth.signIn}
      </Button>
    </form>
  );
}
